import { Page } from '@/core/architecture'

import { FirstComeFirstServedDetailTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * FirstComeFirstServedDetail Page
 * Implemented as a practical sample.
 */
export const FirstComeFirstServedDetail: Page = () => {
  const { state, actions } = useViewModel()

  return <FirstComeFirstServedDetailTemplate state={state} {...actions} />
}
